export default __webpack_public_path__ + "static/1165-5b6fd751e6ec0403154bff1ee5ac6d4d.pdf";